export default __webpack_public_path__ + "static/media/buttons-card.083583d0.svg";